var map = {
	"./bike.jpg": 5118,
	"./bike_blur.jpg": 5298,
	"./car.jpg": 9267,
	"./car_blur.jpg": 1208,
	"./christmas_tree.jpg": 9206,
	"./christmas_tree_blur.jpg": 8242,
	"./gummy_bear.jpg": 8721,
	"./gummy_bear_blur.jpg": 2238,
	"./helicopter.jpg": 6661,
	"./helicopter_blur.jpg": 4610,
	"./newspaper.jpg": 9565,
	"./newspaper_blur.jpg": 3979,
	"./press.jpg": 5617,
	"./press_blur.jpg": 4780,
	"./tape.jpg": 7978,
	"./tape_blur.jpg": 229,
	"./thermos.jpg": 1328,
	"./thermos_blur.jpg": 621,
	"./toothpaste.jpg": 900,
	"./toothpaste_blur.jpg": 388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8532;